import React from "react";
import brand from "../content/brand";

const Metrics = () => (
  <section className="metrics">
    <div className="shell">
      <div className="row">
        {brand.status.map((s) => (
          <div key={s.code} className="cell">
            <div className="head"><span className="dot" /><span>STATUS · {s.code}</span></div>
            <div className="v">{s.value}</div>
            <div className="l">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Metrics;
